var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.651562 0.5H4.35156L3.72656 12.2H1.25156L0.651562 0.5ZM2.50156 18.175C1.91823 18.175 1.4349 17.9917 1.05156 17.625C0.668229 17.2417 0.476562 16.775 0.476562 16.225C0.476562 15.675 0.668229 15.2167 1.05156 14.85C1.4349 14.4833 1.91823 14.3 2.50156 14.3C3.06823 14.3 3.5349 14.4833 3.90156 14.85C4.2849 15.2167 4.47656 15.675 4.47656 16.225C4.47656 16.775 4.2849 17.2417 3.90156 17.625C3.5349 17.9917 3.06823 18.175 2.50156 18.175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.eac0c80d9d7d744d58f94cf51442b16a.svg";
export { ForwardRef as ReactComponent };